import { render, staticRenderFns } from "./SurveyInitialQuestionCard.vue?vue&type=template&id=574d7e0c&"
import script from "./SurveyInitialQuestionCard.vue?vue&type=script&lang=ts&"
export * from "./SurveyInitialQuestionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports